APIService.$inject = [
  'Restangular',
  'alerts',
  '$timeout',
  'Echo',
  '$rootScope',
  'Analytics',
  'SessionSync',
];

/* @ngInject */
function APIService (
  Restangular,
  alerts,
  $timeout,
  Echo,
  $rootScope,
  Analytics,
  SessionSync
) {
  //content negotiation
  var headers = {
    'Content-Type': 'application/json',
    'X-CSRF-TOKEN': Laravel.crsfToken,
  };

  var API = Restangular.withConfig (function (RestangularConfigurer) {
    RestangularConfigurer.setBaseUrl ('/c/')
      .setDefaultHeaders (headers)
      .setErrorInterceptor (function (response) {
        if (!response.data) {
          // Offline maybe
          return false;
        }
        var err = response.data.error;

        if (response.status === 500 && err) {
          alerts.error ('Error!', err.message);
          $rootScope.$broadcast ('500_error', err);
          return;
        }

        if (response.status === 401 && err) {
          if (err.name === 'UnauthenticatedUser') {
            alerts
              .error ('Error!', err.message)
              .finally (window.location.reload);

            Analytics.trackException (err.name + ': ' + err.message, false);
            
            // Notify other tabs about the session expired
            SessionSync.broadcastSessionExpired();
            
            $rootScope.$broadcast ('user:logout', {
              message: err.message,
            });

            return false; // error handled
          } else if (err.name === 'InvalidCrsfToken') {
            API.updateCSRF ();

            Analytics.trackException (err.name + ': ' + err.message, false);
            alerts.error ('¡Error!', err.message, {
              buttons: {
                ok: {
                  html: 'Reconectar',
                  class: 'btn-success btn-lg',
                },
              },
            });
            $rootScope.$broadcast ('user:logout', {});
          }
        }

        return true; // error not handled
      })
      .setResponseExtractor (function (response) {
        API.lastResponse = Date.now ();
        // Includes pagination
        if (response.meta) {
          return response;
        }
        return response.data;
      });
  });

  API.lastResponse = null;

  API.updateCSRF = function () {
    return API.one ('keepalive').get ().then (function (response) {
      Laravel.crsfToken = response.token;
      API.setDefaultHeaders ({
        'X-CSRF-TOKEN': response.token,
      });
      Echo.updateCsrfToken (response.token);
    });
  };

  return API;
}

export default APIService;